module.exports = __webpack_public_path__ + "static/media/arrow.1a56b3bc.svg";